import { render, staticRenderFns } from "./resumo.vue?vue&type=template&id=94a7f344"
import script from "./resumo.vue?vue&type=script&lang=js"
export * from "./resumo.vue?vue&type=script&lang=js"
import style0 from "./resumo.vue?vue&type=style&index=0&id=94a7f344&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports